define.alias("ember-power-select/components/power-select-multiple/input", "settings/components/power-select-multiple/input");